export class RegisterUserProperties {

  registerID: number;
  companyName: string;
  email: string;
  fullName: string;
  city: string;
  mobileNo: string;
  country: string;
  district: string;
  address: string;
  visitingCard: File;
  visitingLicense: File| null;
  companyLogo: File| null;
  numberOfTickets: number| null;
  suggestedAmount: number| null;
  bankAccountNumber1: string| null;
  bankAccountNumber2: string| null;
  managerCode?: string | null;
  creditLimit: number;
  creditDays: number;
  isApproved: boolean;
}
